import React, { useState } from "react";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import TableTreeModal from "../BuilderComponents/TableTreeModal";
import Label from "../FormComponents/Label";
import Input from "../FormComponents/Input";
import useFetchData from "../../hooks/useFetchData";
import SingleSelectBox from "../FormComponents/SingleSelectBox";
// import CustomCss from "../BuilderComponents/CustomCss";

const EditFileViewer = ({ editElementData, setEditElementData, tableID }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSelectFile = (data) => {
    const copyData = JSON.parse(JSON.stringify(editElementData));
    copyData.preview_field = data;
    setEditElementData(copyData);
    setIsModalOpen(false);
  };
  // const handleCustomCss = (e) => {
  //   const { name, value } = e.target;
  //   setEditElementData({ ...editElementData, [name]: value });
  // };
  const handleHeightValue = ({ target: { value } }) => {
    const copyData = JSON.parse(JSON.stringify(editElementData));
    copyData.file_viewer_height = parseInt(value);
    setEditElementData(copyData);
  };

  const handleAllowShowPopup = ({ target: { checked, name } }) => {
    setEditElementData((prevData) => ({
      ...prevData,
      [name]: checked
    }));
  };

  const handleFileRepo = (data) => {
    setEditElementData((pre) => {
      return {
        ...pre,
        file_repo: data
      };
    });
  };
  return (
    <>
      <div className="flex_column gap_2">
        <Label className="builder_label">Select Field</Label>
        <div className="builder_input d_flex justify_center cursor_pointer" onClick={() => setIsModalOpen(true)}>
          {!editElementData.preview_field
            ? "No field assign"
            : (editElementData.preview_field.activity_label || "") + "." + editElementData.preview_field.display}
        </div>

        <FileRepoSelections selectedFile={editElementData?.file_repo} onChange={handleFileRepo} />
        <Label className="builder_label">Fixed Height (in Pixels)</Label>
        <Input type="number" value={editElementData?.file_viewer_height || ""} onChange={handleHeightValue} />
        <div className="field_horizontal_container">
          <Input
            type="checkbox"
            label="Allow Show Popup"
            name="allow_show_popup"
            checked={editElementData?.allow_show_popup || false} // The checkbox is now linked to showPopup state
            onChange={handleAllowShowPopup} // Toggles the visibility of the popup
          />
          <Input
            type="checkbox"
            label="Download Only"
            name="download_only"
            checked={editElementData?.download_only || false} // The checkbox is now linked to showPopup state
            onChange={handleAllowShowPopup} // Toggles the visibility of the popup
          />
        </div>
      </div>
      {/* <CustomCss
        value={{
          custom_css: editElementData.custom_css || "",
          custom_id: editElementData.custom_id || "",
          custom_classname: editElementData.custom_classname || ""
        }}
        onChange={handleCustomCss}
      /> */}
      <BuilderModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} modalName="Select Field">
        <TableTreeModal
          callbackFunction={handleSelectFile}
          tableId={tableID}
          selectedFile={editElementData && editElementData?.preview_field && editElementData?.preview_field?.id}
        />
      </BuilderModal>
    </>
  );
};

const FileRepoSelections = ({ selectedFile, onChange, label = "Select File" }) => {
  const { data, loading, error } = useFetchData("/file_repo");
  if (loading) return <div>Loading...</div>;
  if (error) return <div>Something went wrong</div>;
  return (
    <div className="builder_form">
      <SingleSelectBox
        selectedData={selectedFile}
        options={data}
        onChange={(obj) => onChange(obj.id)}
        label={label}
        placeholder={label}
      />
    </div>
  );
};

export default EditFileViewer;
